import { memo } from 'react';
import { Modal, Text } from '@shopify/polaris';
import { AI_STRINGS } from '../../config';

interface IDisconnectModalProps {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DisconnectModal = ({ open, loading, onCancel, onConfirm }: IDisconnectModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={AI_STRINGS.MODAL_TITLE}
      primaryAction={{
        content: AI_STRINGS.BUTTON_DISCONNECT,
        onAction: onConfirm,
        loading,
        destructive: true,
      }}
      secondaryActions={[{ content: AI_STRINGS.BUTTON_CANCEL, onAction: onCancel }]}
    >
      <Modal.Section>
        <Text as="p">{AI_STRINGS.MODAL_BODY}</Text>
      </Modal.Section>
    </Modal>
  );
};

export default memo(DisconnectModal);
